const updates = [
  { date: '2026-07-28', title: '刃牙道 第126话更新', desc: '最新话已上线，继续刃牙与勇次郎的终极对决', tag: '新', tagClass: 'bg-primary-500' },
  { date: '2026-07-26', title: '烈海王异世界 第36话更新', desc: '烈海王在新世界的冒险进入全新阶段', tag: '新', tagClass: 'bg-primary-500' },
  { date: '2026-07-24', title: '花山薰外传 第24话更新', desc: '终于揭开花山薰少年时代的秘密过往', tag: '新', tagClass: 'bg-primary-500' },
  { date: '2026-07-22', title: '站点服务器全面升级', desc: '刃牙漫画在线阅读加载速度提升40%，下拉式体验更流畅', tag: '公告', tagClass: 'bg-accent-500' },
  { date: '2026-07-20', title: '刃牙动画联动专题上线', desc: '新增动画漫画逐帧对比栏目，深度解析刃牙动画化改编', tag: '专题', tagClass: 'bg-secondary-500' },
  { date: '2026-07-18', title: '移动端阅读体验优化', desc: '刃牙漫画在线看手机版界面焕新，阅读更舒适', tag: '优化', tagClass: 'bg-accent-500' },
  { date: '2026-07-15', title: '范马刃牙全集高清重制', desc: '刃牙漫画全集经典篇章画质全面升级至高清版本', tag: '重制', tagClass: 'bg-secondary-500' },
  { date: '2026-07-12', title: '新增夜间阅读模式', desc: '刃牙漫画免费在线阅读支持深色主题，保护夜间阅读视力', tag: '功能', tagClass: 'bg-accent-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          更新动态
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14">
          刃牙漫画平台最新内容与功能更新
        </p>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300/60 hidden sm:block"></div>
          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-5 items-start">
                <div className="hidden sm:flex flex-shrink-0 w-10 h-10 rounded-full bg-background-50 border-2 border-background-300/60 items-center justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 bg-background-100 border border-background-200/70 rounded-2xl p-4 md:p-5">
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className={`px-2 py-0.5 rounded-full ${item.tagClass} text-white text-xs font-medium whitespace-nowrap`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}